import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from 'antd';
export function MessageDetail(props) {
    return (_jsx(Modal, { title: "\u6D88\u606F\u8BE6\u60C5", ...props, children: _jsxs("div", { style: { margin: '0 auto', textAlign: 'center' }, children: [_jsx("div", { children: "\u56E2\u961F\u540D\u79F0\uFF1Axxxx" }), _jsx("div", { children: "\u56E2\u961F\u7801\uFF1Axxxx" })] }) }));
}
